export default "__VITE_ASSET__CXSnHO9g__"